import { SearchIcon } from 'lucide-react';
import type { ComponentProps } from 'react';
import { Input } from '@/components/ui/input';
import { cn } from '@/lib/utils';

type SearchInputProps = ComponentProps<typeof Input> & {
  /** Classes merged on the wrapping div (defaults to a toolbar width). */
  containerClassName?: string;
};

/**
 * Toolbar search input with a leading search icon, per the mockup pattern.
 *
 * @param props - standard input props plus `containerClassName` for the wrapper
 * @returns a search input with its icon wrapper
 */
export const SearchInput = ({
  containerClassName,
  className,
  ...props
}: SearchInputProps) => {
  return (
    <div className={cn('relative w-full md:w-[280px]', containerClassName)}>
      <SearchIcon
        className="pointer-events-none absolute top-1/2 left-2.5 size-4 -translate-y-1/2 text-muted-foreground"
        aria-hidden
      />
      <Input
        type="search"
        className={cn('pl-8', className)}
        {...props}
      />
    </div>
  );
};
